import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=3058256e&scoped=true&"
import script from "./product_detail.vue?vue&type=script&lang=js&"
export * from "./product_detail.vue?vue&type=script&lang=js&"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=3058256e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3058256e",
  null
  
)

export default component.exports